var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderClosed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_372_1738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5938 0H0.59375V18H18.5938V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_372_1738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3438 8.0625C16.3438 7.01414 16.3438 6.30245 16.1725 5.88896C15.9441 5.33765 15.5061 4.89963 14.9548 4.67127C14.5413 4.5 14.0171 4.5 12.9688 4.5C12.1973 4.5 11.4258 4.5 10.6544 4.5C10.5279 4.5 10.4647 4.5 10.4038 4.49669C9.89195 4.46891 9.4049 4.26718 9.0233 3.92488C8.97785 3.88413 8.93315 3.83942 8.84375 3.75C8.75433 3.66058 8.70962 3.61587 8.6642 3.57512C8.28261 3.23282 7.79557 3.03109 7.2837 3.00331C7.22278 3 7.15955 3 7.03309 3C6.83665 3 6.6402 3 6.44375 3C5.18363 3 4.55357 3 4.07227 3.24523C3.6489 3.46095 3.3047 3.80515 3.08898 4.22852C2.84375 4.70982 2.84375 5.33988 2.84375 6.6C2.84375 8.2 2.84375 9.8 2.84375 11.4C2.84375 12.6602 2.84375 13.2901 3.08898 13.7715C3.3047 14.1949 3.6489 14.539 4.07227 14.7548C4.55357 15 5.18363 15 6.44375 15C7.49375 15 8.54375 15 9.59375 15",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84375 8.25C2.84375 8.25 2.84375 10.35 2.84375 11.4C2.84375 12.6601 2.84375 13.2902 3.08898 13.7715C3.3047 14.1949 3.6489 14.539 4.07227 14.7548C4.55357 15 5.18363 15 6.44375 15C8.54375 15 10.6437 15 12.7437 15C14.0039 15 14.6339 15 15.1152 14.7548C15.5386 14.539 15.8828 14.1949 16.0985 13.7715C16.2253 13.5227 16.2865 12.3362 16.3161 11.1029C16.3438 9.9505 16.3438 8.75721 16.3438 8.25H2.84375Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderClosed);
export default __webpack_public_path__ + "static/media/folderClosed.e0a682912c51d65b06ff743621e9bd27.svg";
export { ForwardRef as ReactComponent };